<div class="row d-flex align-items-center ps-1 pe-2">
  <div class="col-sm-12 pe-0 tab-header-container text-start" [ngClass]="firstColumnWidth">
    <div class="d-inline-block" title={{getTitleString()}}>
      <span class="d-inline-block tab-name"> {{tabName}}: </span>
      <span *ngIf="!compareDate(startDateHeading, endDateHeading)" class="d-inline-block ps-2 date-range">
        <span>{{startDateHeading | date:'MMM dd, yyyy'}}</span>
        <span class="px-2" *ngIf="filter == 'range' || isResetAll">to</span>
        <span class="px-2" *ngIf="filter == 'multiple'">...</span>
        <span>{{endDateHeading | date:'MMM dd, yyyy'}}</span>
        <span class="ps-2" *ngIf="filter == 'multiple'">({{dateRange.length}} days)</span>
        <span class="px-2">(UTC)</span>
      </span>
    </div>
    <div *ngIf="compareDate(startDateHeading, endDateHeading)" class="d-inline-block ps-2 date-range"
      title={{getTitleString()}}>
      <span>{{startDateHeading | date:'MMM dd, yyyy'}}</span>
      <span class="px-2">(UTC)</span>
    </div>
    <div *ngIf="description && description['descriptionFirst'] || description && description['descriptionThird']"
      class="ellipsis-cls">
      <small *ngIf="description['descriptionFirst']" class="text-secondary"
        title={{setDescriptiontitle()}}>{{setDescriptiontitle()}}</small>
      <small *ngIf="description.isPointCodeModalVisible" class="text-secondary"> Please click <p
          class="m-0 d-inline-block point-codes-cls" attr.data-html="{{description.html}}"
          attr.data-bs-toggle="{{description.dataToggle}}" attr.data-target="{{description.id}}"
          (click)="onOpenPointCodesModal()">here</p> for Point Code migration details.</small>
      <small *ngIf="description['descriptionThird']" class="text-secondary fw-bolder"
        title={{getDescriptionVolumeTitle()}}>{{description.descriptionThird}}</small>
      <small *ngIf="description['descriptionFourth']" class="text-secondary"
        title={{getDescriptionVolumeTitle()}}>{{description.descriptionFourth}}</small>
    </div>
  </div>
  <div class="col-sm-12 ps-1 text-end pills-header-container d-flex justify-content-end"
    [ngClass]="secondColumnWidth">

    <!-- Verstat and Robocall toggle for CVT tab -->
    <div *ngIf="isVerstatToggleVisible && activeBoundType === 'Terminating'" class="verstat-radiobutton pt-2">
      <p-radioButton name="CVT" value="Robocall" label="Robocall" [(ngModel)]="selectedCVTView" inputId="Robocall"
        (onClick)="verstatToggle($event)">
      </p-radioButton>
      <p-radioButton name="CVT" value="Verstat" label="{{verstatCustomLabel}}" [(ngModel)]="selectedCVTView" inputId="Verstat"
        class="ps-2" (onClick)="verstatToggle($event)">
      </p-radioButton>
    </div>
    <span *ngIf="overlayScore" class="d-inline-block px-3 score-header pt-2" title="Robocall Score: All"> Robocall
      Score:
      {{overlayScore}} </span>
    <!-- <span class="d-inline-block" *ngIf="showGroupByObj">
      <ul class="nav nav-pills nav-fill">
        <li id="tab-header-groupBy-pills" class="nav-item pills-custom" *ngFor="let groupByObj of dayFilterObj; first as isFirst; last as isLast" title="{{groupByObj.key  | titlecase}} Filter"
          [ngClass]="{'first-pill-round': isFirst, 'last-pill-round': isLast}">
          <a id="pills" class="nav-link" data-bs-toggle="pill" (click)="selectgroupByParam(groupByObj,maxMinDate,groupByObj.value[0].value)" [ngClass]="{'active': groupByObj.isValueSelected && isDayFilterSelected, 'first-pill-round': isFirst, 'last-pill-round': isLast}">{{groupByObj.label}}</a>
        </li>
      </ul>
    </span> -->

    <span *ngIf="isTimerVisible">
      <ng-container *ngIf="isFilterExpanded; then filterExpanded; else filterCollapsed">
      </ng-container>
    </span>

    <ng-template #filterCollapsed>
      <span [ngClass]="{ 'pointer-auto-refresh' : isAutoRefreshDisabled }"
        class="bg-info-box float-end refresh-info ps-2 pe-2 pointer"
        [attr.title]="isAutoRefreshDisabled ? '' : 'Click to refresh'" (click)="onRefresh(refreshDate)">
        <span class="refresh-time ps-2 pe-2"><i class="fa fa-refresh"
            [ngClass]="{'refresh-icon': isRefreshTime }"></i></span>
        <span *ngIf="display" id="#timer" class="pe-2">{{display}}</span>
        <span class="float-end refresh-label pe-2">
          <span>Last data refresh : {{refreshDate}}</span>
        </span>
      </span>
    </ng-template>
    <ng-template #filterExpanded>
      <span [ngClass]="{ 'pointer-auto-refresh' : isAutoRefreshDisabled }"
        class="bg-info-box float-end refresh-info ps-2 pe-2 pointer" title="Last Data refresh : {{refreshDate}}"
        (click)="onRefresh(refreshDate)">
        <span class="refresh-time ps-2 pe-2"><i class="fa fa-refresh"
            [ngClass]="{'refresh-icon': isRefreshTime }"></i></span>
        <span *ngIf="display" id="#timer" class="pe-2">{{display}}</span>
      </span>
    </ng-template>

    <span class="d-inline-block ps-2 pe-1 ocn-type-dropdown"
      *ngIf="isOCNTypeDropdownVisible && activeBoundType === 'Originating'">
      <p-dropdown class="ocn-type-select" [options]="ocnTypes" [(ngModel)]="selectedOCNType" optionLabel="ocnType"
        (onChange)="selectOCNType($event)">
      </p-dropdown>
    </span>
    <span class="d-inline-block ps-2">
      <ul class="nav nav-pills nav-fill">
        <li id="tab-header-pills" class="nav-item pills-custom"
          *ngFor="let days of dayFilterValues; first as isFirst; last as isLast" title="{{days.label}} Filter"
          [ngClass]="{'first-pill-round': isFirst, 'last-pill-round': isLast}">
          <a id="pills" class="nav-link" data-bs-toggle="pill" (click)="selectDateRange(days.value, maxMinDate, true)"
            [ngClass]="{'active': days.isSelected && isDayFilterSelected, 'first-pill-round': isFirst, 'last-pill-round': isLast}">{{days.label}}</a>
        </li>
      </ul>
    </span>
    <span *ngIf="isThresholdVisible" class="ps-3 pointer thresholdCls">
      <i class="fa fa-sliders range-hover-ripple" aria-hidden="true" data-bs-toggle="modal" data-bs-target="#thresholdModal"
        title="Set Threshold" (click)="onModalOpen()"></i>
    </span>
    <span *ngIf="isBoundTypeVisible" class="ps-3 pointer bound-type-cls"
      [ngClass]="isTerminationActive? 'termination-origination-active': 'termination-origination-deactive'">
      <i class="fa-regular fa-circle-down" aria-hidden="true" title="Terminating at {{activeCustomer}}"
        (click)="setTerminationOrigination('Terminating')"></i>
    </span>
    <span *ngIf="isBoundTypeVisible && selectedCVTView === 'Robocall'" class="ps-3 pointer bound-type-cls"
      [ngClass]="isOriginationActive? 'termination-origination-active': 'termination-origination-deactive'">
      <i class="fa-regular fa-circle-up" aria-hidden="true" title="Originating from {{activeCustomer}}"
        (click)="setTerminationOrigination('Originating')"></i>
    </span>
  </div>
</div>

<!-- Modal -->
<div *ngIf="isThresholdVisible" class="modal fade" id="thresholdModal" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header modal-header-cls">
        <h5 class="mb-0" id="exampleModalLabel">Threshold Selection</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body px-5">
        <!-- <div class="pb-1">
            <span>{{shortenLargeNumber(thresholdConfig.min, 1)}}</span>
            <span class="fw-bolder"></span>
            <span class="float-end">{{shortenLargeNumber(thresholdConfig.max, 1)}}</span>
          </div> -->
        <div class="text-center">
          <div class="slider-thresold pt-4">
            <p-slider #slider [(ngModel)]="threshold" [min]="thresholdConfig.min" [max]="thresholdConfig.max"
              [animate]="true" (onChange)=onThresholdChange($event)>
            </p-slider>
          </div>
        </div>
        <div class="pt-1">
          <span>{{shortenLargeNumber(thresholdConfig.min, 1)}}</span>
          <span class="fw-bolder"></span>
          <span class="float-end">{{shortenLargeNumber(thresholdConfig.max, 1)}}</span>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary close-btn" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" (click)="setThreshold(threshold)">Submit</button>
      </div>
    </div>
  </div>
</div>
